import { FC, useEffect } from "react"
import React, { useState } from "react"
import {
  Box,
  Dialog,
  Select,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableRow,
  Pagination,
  Paper,
  Typography,
} from "@mui/material"
import { UButton } from "@/components/index"
import { ExpandMore } from "@mui/icons-material"
import UTableSearch from "../PatientList/components/UTable/UTableSearch"
import PersonIcon from "@mui/icons-material/Person"

import { useAppDispatch, useAppSelector, useDeepEffect } from "@/core/app/hooks"
import { RootState } from "@/core/app/store"
import {
  get3ShapeCaseList,
  getBirthdayfor3Shape,
} from "@/core/app/slices/patients/patientThunkApi"
import useLocalStorageListener from "@/modules/Settings/Integrations/localStorageHooks"
import {
  setData,
  setMeditLoginPopUp,
} from "@/core/app/slices/patients/patientSlice"
import { usePageHeight } from "@/UDTreat/top/GetViewWidth"
import { debounce } from "lodash"

import { getCaseDetail } from "@/core/global/ThirdDataMgr"
import { getCaseByUuid } from "@/core/global/httpMedit"
import { getBirthday } from "@/core/global/http3Shape"
import { getPatientslist } from "@/core/global/httpAlliedstar"
import DialogActions from "@mui/material/DialogActions"
import DialogContent from "@mui/material/DialogContent"
import DialogContentText from "@mui/material/DialogContentText"
import DialogTitle from "@mui/material/DialogTitle"
const { VITE_DOMAIN } = import.meta.env
const ScannerPatients: FC = ({
  showScannerPatients,
  setShowScannerPatients,
  choosePatient,
}) => {
  const dispatch = useAppDispatch()
  const {
    caseListFor3Shape,
    scannerSelect,
    scannerCaseListCount,
    meditLoginPopUp,
  } = useAppSelector((state: RootState) => state.patientService)
  console.log("980caseListFor3Shape", caseListFor3Shape)
  const [filterList, setFilterList] = useState<any[]>([])
  // search text
  const [searchText, setSearchText] = useState<string>("")
  useEffect(() => {
    if (!showScannerPatients) {
      setSearchText("")
    }
  }, [showScannerPatients])
  // table page
  const [page, setPage] = useState(0)
  const [rowsPerPage, setRowsPerPage] = useState(10)
  const formatUTC = (dateStr) => {
    if (!dateStr) {
      return ""
    }
    const date = new Date(dateStr)

    // 提取UTC时间分量
    const month = date.getUTCMonth() + 1 // 0-11 → 1-12
    const day = date.getUTCDate()
    const year = date.getUTCFullYear()
    let hours = date.getUTCHours()
    const minutes = String(date.getUTCMinutes()).padStart(2, "0")

    // 转换为12小时制AM/PM
    const period = hours >= 12 ? "PM" : "AM"
    hours = hours % 12 || 12 // 0点转为12 AM

    return `${month}/${day}/${year}, ${hours}:${minutes} ${period}`
  }

  const [scannerSelectData, setScannerSelectData] = useState([])
  // locastorage key  3shapeData， meditData, alliesData
  const shapeLocal = useLocalStorageListener("3shapeData", null)
  const meditDataLocal = useLocalStorageListener("meditData", null)
  const alliesDataLocal = useLocalStorageListener("alliesData", null)

  // get scanner list params
  const [listParams, setListParams] = useState<{
    page: number
    type: string
    name: string
  }>({ page: 0, type: "", name: "" })

  //set scanner select array data
  useDeepEffect(() => {
    const tmp = []
    if (shapeLocal) {
      const shapeScanner = JSON.parse(
        localStorage.getItem("3shapeData") || "{}",
      )
      tmp.push({
        name: "3Shape",
        key: "3Shape",
        isPrimary: shapeScanner.isPrimary,
        localName: "3shapeData",
      })
    }
    if (meditDataLocal) {
      const meditScanner = JSON.parse(localStorage.getItem("meditData") || "{}")
      tmp.push({
        name: "Medit",
        key: "Medit",
        isPrimary: meditScanner.isPrimary,
        localName: "meditData",
      })
    }
    if (alliesDataLocal) {
      const allieScanner = JSON.parse(
        localStorage.getItem("alliesData") || "{}",
      )
      tmp.push({
        name: "Alliedstar",
        key: "Alliedstar",
        isPrimary: allieScanner.isPrimary,
        localName: "alliesData",
      })
    }
    setScannerSelectData(tmp)
  }, [shapeLocal, meditDataLocal, alliesDataLocal])
  // set primary select
  useDeepEffect(() => {
    if (scannerSelectData.length) {
      let primaryScanner = ""
      scannerSelectData.map((i) => {
        if (i.isPrimary) {
          primaryScanner = i.key
        }
      })
      dispatch(setData({ scannerSelect: primaryScanner }))
      setListParams({ page: 0, type: primaryScanner, name: "" })
    }
  }, [scannerSelectData])
  useDeepEffect(() => {
    setPage(0)
    setListParams({ page: 0, name: searchText, type: listParams.type })
  }, [searchText])

  useDeepEffect(() => {
    setListParams({ page: page, name: searchText, type: listParams.type })
  }, [page])
  useEffect(() => {
    if (caseListFor3Shape) {
      setFilterList([...caseListFor3Shape])
    }
  }, [caseListFor3Shape])

  // get scanner list data
  useDeepEffect(() => {
    if (listParams.type !== "" && showScannerPatients) {
      dispatch(
        get3ShapeCaseList({
          page: listParams.page,
          type: listParams.type,
          name: listParams.name,
        }),
      )
    }
  }, [listParams.type, listParams.name, listParams.page, showScannerPatients])
  const windowHeight = usePageHeight()

  const handleCaseDetail = (row) => {
    if (scannerSelect === "3Shape") {
      // stl and image
      const { Scans = [], Attachments = [], Info } = row
      const obj = {}
      Scans.map((i) => {
        if (i.FileType === "stl" && i.Href) {
          if (i.JawType === "upper") {
            const pre = i.Href.split("attachments")[0]
            obj.upper = `${pre}attachments/${i.Hash}`
          }
          if (i.JawType === "lower") {
            const pre = i.Href.split("attachments")[0]
            obj.lower = `${pre}attachments/${i.Hash}`
          }
        }
      })
      const imageTmp = []
      let birthHref = ""
      Attachments.map((i) => {
        if (["png", "jpg", "jpeg"].includes(i.FileType) && i.Href) {
          const obj = {}
          const pre = i.Href.split("attachments")[0]
          obj.href = `${pre}attachments/${i.Hash}`
          obj.name = i.Name
          obj.fileType = `image/${i.FileType}`
          imageTmp.push(obj)
        }
        if (i.FileType === "html") {
          birthHref = i.Href
        }
      })
      let InfoObj = JSON.parse(JSON.stringify(Info)) || {}
      obj.Info = InfoObj
      obj.Scans = Scans
      obj.Attachments = imageTmp
      let comment = ""
      if (row.Info.Comments.length > 0) {
        row.Info.Comments.map((i) => {
          // getCaseComment(row.Info.CaseId, i.id).then((res) => {
          //   if (res) {
          //     // setValue("notes", res)
          //     comment += res + "\n"
          //   }
          // })
          comment += i.ShortComment + "\n"
        })
      }
      obj.Info.notes = comment
      obj.Info.year = ""
      obj.Info.month = ""
      obj.Info.day = ""
      // set birthday
      if (birthHref !== "") {
        console.log("3shapebirth_param_ui", birthHref)
        try {
          dispatch(getBirthdayfor3Shape({ url: birthHref })).then((res) => {
            console.log("Birthday res", res)
            if (res) {
              const { payload } = res
              const { year, month, day } = payload
              obj.Info.year = year || ""
              obj.Info.month = month || ""
              obj.Info.day = day || ""
            }
            dispatch(setData({ caseDetailForShape: obj }))
            choosePatient && choosePatient(obj)
          })
        } catch (error) {
          console.error(error)
          obj.Info.year = ""
          obj.Info.month = ""
          obj.Info.day = ""
          dispatch(setData({ caseDetailForShape: obj }))
          choosePatient && choosePatient(obj)
        }
      } else {
        dispatch(setData({ caseDetailForShape: obj }))
        choosePatient && choosePatient(obj)
      }
    }
    if (scannerSelect === "Alliedstar") {
      const detail = JSON.parse(JSON.stringify(row))
      getCaseDetail({ type: "Alliedstar", id: row.Info.CaseId }).then((res) => {
        if (res && res.attachments) {
          const scanTmp = []
          const imageTmp = []
          res.attachments.map((i) => {
            if (i.fileFormat === "stl") {
              scanTmp.push(i)
            } else {
              imageTmp.push(i)
            }
          })
          detail.Attachments = imageTmp
          detail.Scans = scanTmp
          detail.Info.notes = res.comment
          detail.Info.year = ""
          detail.Info.month = ""
          detail.Info.day = ""
          // setValue("notes", res.comment)
          getPatientslist(res.patientName, res.patientId).then((res1) => {
            if (res1 && res1.data) {
              if (res1.data.data[0] && res1.data.data[0].birthDate) {
                const dob = res1.data.data[0].birthDate.split("T")[0].split("-")
                detail.Info.month = dob[1] || ""
                detail.Info.day = dob[2] || ""
                detail.Info.year = dob[0] || ""
              }
            }
            choosePatient && choosePatient(detail)
            dispatch(setData({ caseDetailForShape: detail }))
          })
        }
      })
    }
    if (scannerSelect === "Medit") {
      const detail = JSON.parse(JSON.stringify(row))
      getCaseByUuid(row.Info.CaseId).then((res) => {
        if (res && res.data.files) {
          const scanTmp = []
          const imageTmp = []
          const keywords = ["mandibular", "maxillary"]
          const imageKeywords = ["jpg", "png", "jpeg"]
          res.data.files.map((i) => {
            if (keywords.some((keyword) => i.name.includes(keyword))) {
              scanTmp.push(i)
            } else if (
              imageKeywords.some((keyword) =>
                i.name.toLowerCase().includes(keyword),
              )
            ) {
              imageTmp.push(i)
            }
          })
          detail.Attachments = imageTmp
          detail.Scans = scanTmp
        }
        dispatch(setData({ caseDetailForShape: detail }))
      })
      choosePatient && choosePatient(detail)
    }
  }
  useEffect(() => {
    return () => {
      setScannerSelectData([])
      setFilterList([])
      setSearchText("")
      setPage(0)
      setListParams({ page: 0, type: "", name: "" })
    }
  }, [])
  // 清理meditData并处理其余scanner
  const handleMeditData = () => {
    const shapeScanner = JSON.parse(localStorage.getItem("3shapeData") || "{}")
    const meditScanner = JSON.parse(localStorage.getItem("meditData") || "{}")
    const deleteStorageObj = {
      name: scannerSelect,
      key: scannerSelect,
      isPrimary:
        scannerSelect === "Medit"
          ? meditScanner.isPrimary
          : shapeScanner.isPrimary,
      localName: scannerSelect === "Medit" ? "meditData" : "3shapeData",
    }
    let preparatoryPrimary = ""
    if (deleteStorageObj.isPrimary && scannerSelectData.length > 1) {
      scannerSelectData.forEach((item) => {
        if (item.name !== deleteStorageObj.name) {
          preparatoryPrimary = item.localName
        }
      })
    }
    localStorage.removeItem(deleteStorageObj.localName)
    if (preparatoryPrimary !== "") {
      const userStr = localStorage.getItem(preparatoryPrimary)
      if (userStr) {
        const userObj = JSON.parse(userStr)
        userObj.isPrimary = true
        localStorage.setItem(preparatoryPrimary, JSON.stringify(userObj))
      }
    }
    const url =
      scannerSelect === "Medit"
        ? `https://openapi-auth.meditlink.com/oauth/authorize?client_id=A05M4Esrwv8WBW1ybGqSnJ3OQbsjW0q0&response_type=code&redirect_uri=${VITE_DOMAIN}/settings/integrations?from=medit&scope=USER%20GROUP%20CASE%20FILE%20ORDER%20PRODUCT:DENTAL%20FILE:MANAGE%20ORDER:MANAGE&state=bn6q6ru91ygkzwo8rfc0s1f7`
        : `https://identity.3shape.com/connect/authorize?client_id=UlUTXMHM7GGRTVb&response_type=code&scope=openid+api+offline_access+communicate.connections.manage+data.companies.read_only+data.users.read_only&redirect_uri=${VITE_DOMAIN}/settings/integrations&code_challenge=mwofHihL4F89LWgqhai-9GTAAhJtTIvR5bOqz_3_B9E&code_challenge_method=S256&response_mode=query`
    window.open(url)
  }
  return (
    <>
      <Dialog
        sx={{
          "& .MuiDialog-container": {
            height: "100%",
          },
          "& .MuiPaper-root": {
            borderRadius: "16px",
          },
          "& .MuiDialog-paper": {
            maxHeight: "92%",
            aspectRatio: 0.652,
            overflow: "hidden",
          },
        }}
        open={showScannerPatients}
      >
        <Box
          sx={{
            width: 564,
            height: 864,
            minHeight: 864,
            padding: "32px",
            display: "flex",
            flexDirection: "column",
            transform: `scale(${
              windowHeight / 945 > 1 ? 1 : windowHeight / 945
            })`,
            transformOrigin: "top left",
          }}
        >
          <Box sx={{ height: "96px", width: "100%" }}>
            <Select
              value={scannerSelect}
              sx={{
                "& .MuiInputBase-root": {
                  height: "32px",
                },
                "& .MuiSelect-select": {
                  padding: "0 32px 0 0",
                  fontSize: "24px",
                  color: "rgba(0,0,0,0.87)",
                  minHeight: "unset !important",
                },
                "& .MuiSvgIcon-root": {
                  right: "0",
                },
                "& .MuiOutlinedInput-notchedOutline": {
                  display: "none",
                  border: "none", // 去除默认边框
                },
                "&:hover .MuiOutlinedInput-notchedOutline": {
                  border: "none", // 去除悬停状态边框
                },
                "&.Mui-focused .MuiOutlinedInput-notchedOutline": {
                  border: "none", // 去除聚焦状态边框
                },
              }}
              IconComponent={ExpandMore} // 替换为 Material-UI 内置图标
              // MenuProps={{
              //   PaperProps: {
              //     sx: {
              //       "& .MuiMenuItem-root": { padding: "8px 16px" },
              //     },
              //   },
              // }}
              onChange={(eve) => {
                setSearchText("")
                setPage(0)
                setListParams({ page: 0, type: eve.target.value, name: "" })
                dispatch(setData({ scannerSelect: eve.target.value }))
              }}
            >
              {scannerSelectData.map((i) => {
                return (
                  <MenuItem key={i.key} value={i.name}>
                    {i.name}
                  </MenuItem>
                )
              })}
            </Select>
            <Box sx={{ width: "100%", margin: "16px 0" }}>
              <UTableSearch
                onSearch={debounce((value) => {
                  setSearchText(value)
                }, 1000)}
                searchText={searchText}
              />
            </Box>
          </Box>
          <Box sx={{ flex: 1, overflow: "hidden" }}>
            <TableContainer
              component={Paper}
              sx={{
                border: "0",
                borderRadius: "4px !important",
                boxShadow: "none",
                background: "rgba(0,0,0,0.12)",
                borderColor: "rgba(0,0,0,0.23)",
                marginTop: "3px",
                padding: "0 10px",
                "& .MuiTable-root": {
                  borderSpacing: "0 7px", // 纵向间隙高度
                  borderCollapse: "separate", // 必须设置
                },
              }}
            >
              <Table aria-label="scanner patients" size="small">
                <TableBody>
                  {/* .slice(page * rowsPerPage, (page + 1) * rowsPerPage) */}
                  {filterList &&
                    filterList.map((row) => (
                      <TableRow
                        sx={{
                          background: "#fff",
                          height: "48px",
                          padding: "17px",
                          borderRadius: "4px",
                          overflow: "hidden",
                          cursor: "pointer",
                          "&:first-of-type": {
                            borderTopLeftRadius: "4px",
                            borderTopRightRadius: "4px",
                          },
                          "&:last-of-type": {
                            borderBottomLeftRadius: "4px",
                            borderBottomRightRadius: "4px",
                          },
                          "&:hover": {
                            backgroundColor: "#f5f5f5", // 自定义颜色‌:ml-citation{ref="3,4" data="citationList"}
                            boxShadow: "0 2px 8px rgba(0,0,0,0.1)", // 添加投影效果‌:ml-citation{ref="3" data="citationList"}
                          },
                        }}
                        key={row.Info.CaseId}
                        onClick={() => {
                          setShowScannerPatients(false)
                          handleCaseDetail(row)
                        }}
                      >
                        <TableCell
                          sx={{
                            border: "none",
                            "&:first-of-type": {
                              borderLeft: "1px solid #e0e0e0",
                              borderTopLeftRadius: "inherit", // 继承行级圆角
                              borderBottomLeftRadius: "inherit",
                            },
                            "&:last-of-type": {
                              borderRight: "1px solid #e0e0e0",
                              borderTopRightRadius: "inherit",
                              borderBottomRightRadius: "inherit",
                            },
                          }}
                        >
                          <Box
                            sx={{
                              height: "40px",
                              display: "flex",
                              alignItems: "center",
                              fontSize: "16px",
                            }}
                          >
                            <PersonIcon
                              sx={{
                                fontSize: "40px",
                                color: "#9E9E9E",
                                marginRight: "16px",
                              }}
                            />
                            <span
                              style={{
                                width: "200px",
                                overflow: "hidden",
                                textOverflow: "ellipsis",
                                whiteSpace: "nowrap",
                              }}
                            >
                              {row.Info.PatientName}
                            </span>
                          </Box>
                        </TableCell>
                        <TableCell
                          sx={{
                            border: "none",
                            color: "rgba(0,0,0,0.6)",
                            textAlign: "right",
                            "&:first-of-type": {
                              borderLeft: "1px solid #e0e0e0",
                              borderTopLeftRadius: "inherit", // 继承行级圆角
                              borderBottomLeftRadius: "inherit",
                            },
                            "&:last-of-type": {
                              borderRight: "1px solid #e0e0e0",
                              borderTopRightRadius: "inherit",
                              borderBottomRightRadius: "inherit",
                            },
                          }}
                        >
                          {formatUTC(row.Info.CreateTime)}
                        </TableCell>
                      </TableRow>
                    ))}
                </TableBody>
              </Table>
            </TableContainer>
          </Box>
          <Box
            sx={{
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              gap: 6,
              paddingRight: 2,
            }}
          >
            <Pagination
              count={Math.ceil(scannerCaseListCount / rowsPerPage)}
              page={page + 1}
              onChange={(e, newPage) => setPage(newPage - 1)}
              sx={{
                display: "flex",
                justifyContent: "center",
                mt: 2.5,
                padding: "0 0 0 55px",
                "& .MuiPagination-ul": {
                  flexWrap: "nowrap",
                },
                maxWidth: "348px",
              }}
              showFirstButton
              showLastButton
              siblingCount={0}
              boundaryCount={1}
            />
            <Typography
              variant="body2"
              sx={{
                mt: 2.5,
                whiteSpace: "nowrap",
                fontSize: "14px",
                color: "rgba(0,0,0,0.6)",
              }}
            >
              {page * rowsPerPage + 1}-
              {page * rowsPerPage + rowsPerPage > scannerCaseListCount
                ? scannerCaseListCount
                : page * rowsPerPage + rowsPerPage}{" "}
              of {scannerCaseListCount}
            </Typography>
          </Box>
          <Box
            sx={{
              marginTop: "16px",
              height: "36px",
              width: "100%",
              display: "flex",
              justifyContent: "end",
            }}
          >
            <UButton
              variant="contained"
              btnText={"Close"}
              sxProp={{
                width: "78px",
                height: "36px",
                padding: "6px 16px",
                background: "#e0e0e0",
                color: "rgba(0,0,0,0.87)",
              }}
              onClickHandler={() => {
                setShowScannerPatients(false)
                // dispatch(setData({ caseListFor3Shape: [] }))
                // scannerSelectDataReady.current = false
              }}
            ></UButton>
          </Box>
        </Box>
      </Dialog>
      <Dialog open={meditLoginPopUp}>
        {/* <DialogTitle id="alert-dialog-title">
          Scanner login token expired, need to sign-in again from scanner
            login page.
        </DialogTitle> */}
        <DialogContent>
          <DialogContentText
            id="alert-dialog-description"
            sx={{ color: "rgba(0,0,0,1)", fontSize: "18px" }}
          >
            Scanner login token expired, need to sign-in again from scanner
            login page.
          </DialogContentText>
        </DialogContent>
        <DialogActions>
          <UButton
            variant="contained"
            btnText={"Re-login"}
            sxProp={{
              width: "auto",
              height: "36px",
              padding: "6px 16px",
              // background: "#e0e0e0",
              // color: "rgba(0,0,0,0.87)",
            }}
            onClickHandler={() => {
              // 关闭两个弹窗
              setShowScannerPatients(false)
              dispatch(setMeditLoginPopUp(false))
              // 清理本地medit 数据,并处理其余scanner
              handleMeditData()
            }}
          ></UButton>
        </DialogActions>
      </Dialog>
    </>
  )
}
export default ScannerPatients
